module.exports = __webpack_public_path__ + "pc/img/oneLeft.8e7c542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/oneLeft.png
// module id = KToW
// module chunks = 3